<template>
  <div class="layout-header-logo">
    <ElementLogo :reverse="!!themeObj.style">
      <div class="logo-wrap">
        <a class="logo-mini" v-if="collapsed"></a>
        <a class="logo" v-else></a>
      </div>
    </ElementLogo>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import ElementLogo from './elements/ElementLogo'
export default {
  name: 'LayoutHeaderLogo',
  components: {
    ElementLogo
  },
  props: {
    collapsed: Boolean
  },
  computed: mapState({
    themeObj: state => state.theme
  })
}
</script>

<style lang="scss">
  .layout-header-logo {
    height: 100%;
    .logo-wrap {
      height: 100%;
      padding: 0 5px;
      box-sizing: border-box;
      a {
        display: block;
        width: 100%;
        height: 100%;
        &.logo {
          background: url("../assets/common/logo.png") center no-repeat;
          background-size: contain;
        }
        &.logo-mini {
          background: url("../assets/common/logo.png") center no-repeat;
          background-size: contain;
        }
      }
    }
  }
</style>
